import { MyAccountScreenNavigationProps } from "./types"
import React from "react"
import MyAccount from "./my-account-screen"
import { PageRoot } from "~screens/page-root"


const MyAccountScreen: React.FC<MyAccountScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <MyAccount />
    </PageRoot>
  )
}

export default MyAccountScreen
